/**
 * Sous-domaine dédié à la page publique d’une institution (`{slug}.lyrrastudio.com`).
 * Aligné sur le middleware backend `subdomain.ts` (hôtes réservés, pas d’IP).
 */

const RESERVED_FIRST_LABELS = new Set([
  'www',
  'app',
  'api',
  'admin',
  'mail',
  'cdn',
  'static',
  'v2',
]);

function rootSuffix(): string {
  const raw = import.meta.env.VITE_INSTITUTION_PUBLIC_DOMAIN_SUFFIX;
  return typeof raw === 'string' && raw.trim() !== '' ? raw.trim().toLowerCase() : 'lyrrastudio.com';
}

const SLUG_RE = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

/**
 * Retourne le slug institution (`testui` pour `testui.lyrrastudio.com`) ou `null`.
 */
export function parseInstitutionSubdomainFromHostname(hostname: string): string | null {
  const h = (hostname || '').toLowerCase().trim();
  if (!h || h === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(h)) {
    return null;
  }

  const suffix = rootSuffix();
  const suffixPart = `.${suffix}`;
  if (!h.endsWith(suffixPart)) {
    return null;
  }

  const remainder = h.slice(0, -suffixPart.length);
  if (!remainder || remainder.includes('.')) {
    return null;
  }
  if (RESERVED_FIRST_LABELS.has(remainder)) {
    return null;
  }
  if (!SLUG_RE.test(remainder)) {
    return null;
  }
  return remainder;
}
